import Link from "next/link";

export default function FooterMenuGroup({ title, staticLinks = [], dynamicPages = [] }) {
    return (
        <div className="footer-item">
            <h6 className="footer-item__title">{title}</h6>
            <ul className="footer-menu">
                {staticLinks.map((link) => (
                    <li key={link.slug} className="footer-menu__item">
                        <Link href={`/${link.slug}`} className="footer-menu__link">
                            {link.title}
                        </Link>
                    </li>
                ))}
                {dynamicPages.map((page) => (
                    <li key={page.slug} className="footer-menu__item">
                        <Link href={`/${page.slug}`} className="footer-menu__link">
                            {page.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
